// WhatsApp helpers — number is fetched from /api/settings but has a safe default.
export const DEFAULT_WA = "+971565480837";

export function normalize(num) {
  return (num || DEFAULT_WA).replace(/[^0-9]/g, "");
}

export function waLink(num, message) {
  const phone = normalize(num);
  const text = encodeURIComponent(message || "Hello PIPECO GROUP, I would like to know more about your water storage solutions.");
  return `https://wa.me/${phone}?text=${text}`;
}

export function quoteMessage(productName) {
  if (!productName) return `Hello PIPECO GROUP,\n\nI’m interested in your *Water Storage Tanks* for my project. Could you please share more details and advise on the most suitable option?\n\n*Page reference:*\n${window.location.href}\n\nThank you.`;
  return `Hello PIPECO GROUP, I am interested in your ${productName} solution. Please provide more information and a quotation for my project.`;
}
